'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { Draggable } from 'react-beautiful-dnd';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import Button from '@material-ui/core/Button';
import TextInput from 'Components/Forms/Elements/TextInput';
import Loader from 'Pure/Loader';
import Image from 'Pure/Image';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
let app = window.app;
export default class FileInput extends Component {
  state = {
    id: ++app.form_index,
    loading: false
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    const previews = props.data['__files-' + props.name];
    if (Array.isArray(previews)) return;
    props.onChange({
      e: null,
      previews: [],
      name: props.name,
      source: 'DidMount'
    });
    component.setState({
      loading: false
    });
  }
  removeFile = (e, preview_to_remove) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    let previews = props.data['__files-' + props.name] || [];
    app.emit({
      event: 'documentClick'
    });
    previews = previews.filter(preview => preview !== preview_to_remove);
    component.clearHTMLValue();
    props.onChange({
      e: null,
      previews: previews,
      name: props.name,
      source: 'native-remove'
    });
  };
  handleTitleChange = ({
    e,
    value,
    name,
    index
  }) => {
    const component = this,
      props = this.props,
      state = this.state;

    // Prevent update on DidMount
    if (!e) return;
    let preview = (props.data['__files-' + props.name] || [])[index];
    if (!preview) return;
    preview.title = value;
    props.onChange({
      e: null,
      previews: props.data['__files-' + props.name],
      name: props.name,
      source: 'native-remove'
    });
    component.setState({
      [name]: ''
    });
  };
  clearHTMLValue = () => {
    const component = this,
      props = this.props,
      state = this.state;
    (document.getElementById(state.id) || {}).value = '';
  };
  reorder = (list, source_i, destination_i) => {
    const result = Array.from(list);
    const [removed] = result.splice(source_i, 1);
    result.splice(destination_i, 0, removed);
    return result;
  };
  handleDragEnd = (data = {}) => {
    let component = this,
      props = this.props,
      state = this.state;
    const {
      destination,
      source
    } = data;
    if (!destination || source.index === destination.index) return;
    const previews = props.data['__files-' + props.name] || [];
    props.onChange({
      e: null,
      previews: component.reorder(previews, source.index, destination.index),
      name: props.name,
      source: 'reorder'
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const input_element = /*#__PURE__*/React.createElement("input", {
      type: "file",
      className: "c-form-element__file",
      name: props.name,
      id: state.id,
      onChange: handleChange,
      multiple: props.multiple,
      accept: props.accept
    });
    if (props.hidden === true) return input_element;
    let class_name = props.className || 'c-form-element c-form-element--file';
    let status = props.status[props.name] || {};
    const loader = state.loading === true ? /*#__PURE__*/React.createElement("div", {
      className: "c-form-element__file-loader"
    }, /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['small', 'primary', 'bg-white']
    })) : undefined;
    const label = props.label ? /*#__PURE__*/React.createElement("label", {
      className: "c-form-label c-form-label--file",
      htmlFor: state.id
    }, props.label) : undefined;
    let info, warning, error;
    if (status.info) {
      info = /*#__PURE__*/React.createElement("div", {
        className: "c-form-label c-form-label--info"
      }, status.info);
      class_name += ' c-form-element--info';
    }
    if (status.warning) {
      warning = /*#__PURE__*/React.createElement("div", {
        className: "c-form-label\r c-form-label--file c-form-label--warning"
      }, status.warning);
      class_name += ' c-form-element--warning';
    }
    if (status.error) {
      error = /*#__PURE__*/React.createElement("div", {
        className: "c-form-label\r c-form-label--file c-form-label--error"
      }, status.error);
      class_name += ' c-form-element--error';
    }
    const previews = (props.data['__files-' + props.name] || []).map(function (preview, index) {
      let filename = preview.filename || '';
      let extension = filename.slice(filename.lastIndexOf('.'), filename.length);
      filename = filename.slice(0, filename.indexOf(extension));
      const full_filename = filename + extension;

      // shorten filename if too long and add '...'
      if (filename.length > 20) {
        filename = filename.slice(0, 17) + '...';
      }
      filename += extension;
      let image;
      if (preview.image) {
        image = /*#__PURE__*/React.createElement(Image, {
          className: "c-file-thumbnail__preview",
          src: preview.image,
          title: full_filename,
          alt: full_filename
        });
      } else if (preview.pdf || preview.url?.endsWith('.pdf')) {
        if (preview.url) {
          image = /*#__PURE__*/React.createElement("a", {
            href: preview.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: "c-file-thumbnail__link",
            type: "application/pdf"
          }, /*#__PURE__*/React.createElement(PDFIcon, {
            className: "c-file-thumbnail__icon"
          }));
        } else {
          image = /*#__PURE__*/React.createElement(PDFIcon, {
            className: "c-file-thumbnail__icon"
          });
        }
      } else if (preview.url) {
        image = /*#__PURE__*/React.createElement("a", {
          href: preview.url,
          target: "_blank",
          rel: "noopener noreferrer",
          className: "c-file-thumbnail__link"
        }, /*#__PURE__*/React.createElement(Image, {
          className: "c-file-thumbnail__preview",
          src: preview.url,
          title: full_filename,
          alt: full_filename
        }));
      }
      const title_name = props.multiple === false ? props.name + '[title]' : props.name + '[' + index + '][title]';
      const content = /*#__PURE__*/React.createElement(Fragment, null, image, /*#__PURE__*/React.createElement("div", {
        className: "c-file-thumbnail__title",
        htmlFor: state.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-file-thumbnail__file-name"
      }, filename), /*#__PURE__*/React.createElement(TextInput, {
        onChange: ({
          e,
          value,
          name
        }) => component.handleTitleChange({
          e,
          value,
          name,
          index
        }),
        value: preview.title,
        name: title_name,
        status: props.status
      })), props['read-only'] !== true ? /*#__PURE__*/React.createElement("button", {
        type: "button",
        title: "Enlever",
        className: "c-file-thumbnail__delete",
        onClick: function (e) {
          component.removeFile(e, preview);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "c-file-thumbnail__delete-icon"
      })) : undefined);
      preview.id = preview.id || uniqid();
      let output = /*#__PURE__*/React.createElement(Draggable, {
        key: preview.id,
        draggableId: preview.id,
        index: index
      }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", _extends({
        ref: provided.innerRef
      }, provided.draggableProps, provided.dragHandleProps, {
        className: "c-file-thumbnail"
      }), content));
      return output;
    });
    let toggle = props['read-only'] !== true ? /*#__PURE__*/React.createElement(Button, {
      htmlFor: state.id,
      component: "label",
      className: props['button-class'] || bemit('c-flat-btn')
    }, props.multiple === true ? props['add-label'] || 'Ajouter' : previews.length === 0 ? props['add-label'] || 'Ajouter' : props['edit-label'] || 'Modifier') : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: class_name
    }, label, info, warning, error, /*#__PURE__*/React.createElement("div", {
      className: "c-form-element__file-content"
    }, input_element, props.children, /*#__PURE__*/React.createElement(DragDropContext, {
      onDragEnd: component.handleDragEnd
    }, /*#__PURE__*/React.createElement(Droppable, {
      droppableId: 'droppable-file-' + state.id
    }, (provided, snapshot) => /*#__PURE__*/React.createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), previews, provided.placeholder))), toggle, loader));
    return output;
    function handleChange(e) {
      let new_files = e.target.files;
      e.preventDefault();
      if (props['read-only'] === true) return;
      if (new_files.length === 0) return;
      let previews = props.data['__files-' + props.name] || [];
      component.setState({
        loading: true
      });
      let files_count = new_files.length;
      if (props.multiple === false) {
        files_count = 1;
      }
      for (let i = 0; i < files_count; i++) {
        fileListener(new_files[i]);
      }
      function fileListener(file) {
        let reader = new FileReader();
        reader.onloadend = function () {
          let preview = {
            form_name: props.name,
            pdf: file.type === 'application/pdf',
            image: file.type.startsWith('image/') ? reader.result : undefined,
            filename: file.name,
            file: file,
            type: file.type
          };

          // Remove previous image if only one is allowed
          if (props.multiple === false) {
            previews = [];
          }
          previews.push(preview);
          if (--files_count === 0) {
            component.clearHTMLValue();
            props.onChange({
              e: e,
              previews: previews,
              name: props.name,
              source: 'native-add'
            });
            component.setState({
              loading: false
            });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  }
}
FileInput.propTypes = {
  'read-only': PropTypes.bool,
  multiple: PropTypes.bool,
  hidden: PropTypes.bool,
  name: PropTypes.string.isRequired,
  'button-class': PropTypes.string,
  'edit-label': PropTypes.string,
  'add-label': PropTypes.string,
  className: PropTypes.string,
  accept: PropTypes.string,
  label: PropTypes.string,
  status: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func
};
FileInput.defaultProps = {
  'read-only': false,
  multiple: false,
  hidden: false,
  accept: '.jpg, .jpeg, .png, .svg, .gif, .pdf'
};
